import React, { useEffect } from 'react';
import feather from 'feather-icons';

function Header() {
  useEffect(() => {
    feather.replace();
  });

  const handleLogout = () => {
    localStorage.removeItem('access_token');
    window.location.href = '/login';
  };

  return (
    <nav className="navbar navbar-expand navbar-light bg-white border-bottom px-4">
      <div className="container-fluid">
        <span className="navbar-brand fw-bold">Cranova Admin</span>
        <div className="d-flex align-items-center gap-3">
          <button
            className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
            onClick={handleLogout}
          >
            <i data-feather="log-out" style={{ width: 16, height: 16 }}></i>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Header;
